import { pluralize } from "@suse-o11y/pluralize";
import React from "react";

import { DASHBOARD_PATH } from "../../routes/Routes";
import { LinkTo } from "../react/link/LinkTo";

const pluralizeSuccessToast = pluralize({
	1: "widget has",
	more: "widgets have",
});

export const SuccessMessage: React.FC<{
	type: "existing" | "new";
	dashboardId: number;
	dashboardName: string;
	addedWidgetsCount: number;
}> = ({ type, dashboardId, dashboardName, addedWidgetsCount }) => (
	<p>
		The {pluralizeSuccessToast(addedWidgetsCount)} been successfully added to {type === "new" ? "the new " : "the "}"
		<LinkTo
			params={{ idOrIdentifier: dashboardId }}
			search={["timeRange", "timestamp", "detachedFilters"]}
			theme="secondary"
			to={DASHBOARD_PATH}
		>
			{dashboardName}
		</LinkTo>
		" dashboard.
	</p>
);
